// Action names should be imported from their respective action modules
import {
    COURSES_BEGIN,
    COURSES_SUCCESS,
    COURSES_FAILURE,
    CLEAR_COURSES,
} from 'app/actions/CoursesActions';

// Example initial state
const initialState = {
    byId: {},
    item: {},
    allIds: [],
    isLoading: false,
    error: ''
};

// Return a new state object with updated attributes
export default function CoursesReducer(state = initialState, action) {
    switch (action.type) {
        case COURSES_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case COURSES_SUCCESS:
            return {
                ...state,
                item: action.payload.data,
                isLoading: false,
                error: ''
            }
        case COURSES_FAILURE:
            return {
                ...state,
                error: action.payload.error,
                isLoading: false
            }
        case CLEAR_COURSES:
            return {
                ...state,
                byId: {},
                allIds: [],
                isLoading: false, 
            }
        default:
            return state;
    }
};


export const coursesError = state => {
    return state.error;
}

export const getCoursesById = (state, courseId) => {
    return state.byId[courseId];
}

export const coursesIsLoading = state => {
    return state.isLoading;
}

export const courses = state => {
    return state.item;
}